/**
 * 产品采购规格的会话内缓存（采购行的规格下拉用）。
 * 写规格（加 / 改名 / 停用）、建 / 改采购单（最近单价会变）后由 API 层清掉，下次打开重新读。
 * 只放 Map 和清除函数，不依赖 API，免得和 api.ts 循环引用。
 */
const cache = new Map<string, Promise<unknown>>()

export const purchaseOptionCache = {
  get: (productId: string) => cache.get(productId),
  set: (productId: string, p: Promise<unknown>) => { cache.set(productId, p) },
  delete: (productId: string) => { cache.delete(productId) },
}

/** 清掉一个产品的缓存；不给 id 清全部。 */
export function invalidateProductPackInfo(productId?: string | null) {
  if (productId) cache.delete(String(productId))
  else cache.clear()
}
